import { render, staticRenderFns } from "./ProfileAdminDropdown.vue?vue&type=template&id=186048bd&"
import script from "./ProfileAdminDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileAdminDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports